import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (!res.ok) {
      toast.error(res.error || "Login failed");
      return;
    }
    toast.success("Welcome back!");
    if (res.user.role === "teacher") navigate("/teacher/dashboard");
    else if (res.user.role === "parent") navigate("/parent/dashboard");
    else if (res.user.role === "admin") navigate("/admin/dashboard");
    else navigate("/");
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" data-testid="login-page">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md bg-white rounded-3xl p-8 shadow-sm border border-black/5"
        data-testid="login-form"
      >
        <h1 className="font-display text-3xl font-bold uppercase" style={{ color: "#13A699" }}>
          Welcome Back
        </h1>
        <p className="mt-1 text-sm" style={{ color: "#13A699" }}>Login to your Rate-ED account.</p>

        <label className="block mt-6 text-sm font-semibold" style={{ color: "#13A699" }}>Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1 w-full rounded-xl border border-black/10 px-4 py-3 outline-none focus:ring-2 focus:ring-[#13A699] bg-white text-[#13A699]"
          data-testid="login-email-input"
        />

        <label className="block mt-4 text-sm font-semibold" style={{ color: "#13A699" }}>Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 w-full rounded-xl border border-black/10 px-4 py-3 outline-none focus:ring-2 focus:ring-[#13A699] bg-white text-[#13A699]"
          data-testid="login-password-input"
        />

        <button
          type="submit"
          disabled={submitting}
          className="btn-yellow w-full mt-6 py-3 text-base disabled:opacity-60"
          data-testid="login-submit-btn"
        >
          {submitting ? "Logging in..." : "Login"}
        </button>

        <div className="mt-4 flex items-center justify-between text-sm" style={{ color: "#13A699" }}>
          <Link to="/forgot-password" className="font-semibold" data-testid="login-forgot-password-link">
            Forgot password?
          </Link>
          <Link to="/signup" className="font-semibold" data-testid="login-signup-link">
            Create account
          </Link>
        </div>

        {/* Legal footer — links to Terms & Conditions and Privacy Policy. */}
        <div
          className="mt-8 pt-4 border-t border-black/10 flex items-center justify-center gap-3 text-xs"
          style={{ color: "#13A69999" }}
          data-testid="login-legal-footer"
        >
          <Link to="/terms" className="hover:underline" data-testid="login-terms-link">
            Terms &amp; Conditions
          </Link>
          <span>·</span>
          <Link to="/privacy" className="hover:underline" data-testid="login-privacy-link">
            Privacy Policy
          </Link>
        </div>
      </form>
    </div>
  );
}
